import $ from 'jquery';

const Categories = {

	/**
	 * Select element.
	 *
	 * @type {object}
	 */
	$el: {},

	/**
	 * Initialize.
	 *
	 * @returns {void}
	 */
	init() {
		const that = this;
		this.$el = $( '.c-module__filter' );
		this.$el.each( function( i, e ) {
			const $elem = $(e);
			const $select = $elem.find('select');
			$select.data('owner', $elem.attr('id'));
			$select.on( 'change', that.toggleCategory );
		});
	},

	/**
	 * Toggle podcast category.
	 *
	 * @returns {void}
	 */
	toggleCategory( e ) {
		const targetId      = $(e.target).data('owner');
		const $filter       = $(`#${ targetId }`);
		const category      = $filter.find('.category-select').val();
		const sort          = $filter.find('.sort-select').val().split('|');
		const $target       = $( `[data-select-target="#${ targetId }"]` );
		const distribution = $target.data( 'tax' );

		const query = {
			action: 'cc_category_query',
			category: category,
			distribution: distribution,
			sort_by:  sort[0],
			sort_order: sort[1],
			security: curiousSettings.ajaxNonce
		};

		$.get(curiousSettings.ajaxUrl, query)
			.done( function( data ) {
				$target
					.html('')
					.append( data )
					
				setTimeout( function() {
					$target.parent()
						.removeClass( 'c-dynamic--loading' )
						.css( 'height', $target.height() );
				}, 500);
					
				setTimeout( function() {
					$target.parent().css( 'height', '' );
				}, 1000);

				// update or hide load more
				if ( $target.find('.last-page').length ) {
					$(e.target).closest('.c-module').find('.load-more').hide();
				} else {
					$(e.target).closest('.c-module').find('.load-more').show();
					$(e.target).closest('.c-module').find('.load-more').data('page', 0);
					$target.data('cat', category);
					$target.data('sort', sort);
				}
			});

		$target
			.parent()
			.css( 'height', $target.height() )
			.addClass( 'c-dynamic--loading' );
	}
};

export default Categories;
